<template>
  <div>
    <div class="row">
      <div class="col-md-6 text-right">
        <span class="item-title">{{ $t('message.lblPrijem') }}{{ index + 1 }}</span>
        <button
          type="button"
          class="remove-item btn btn-danger btn-xs"
          @click="zahPar5[index].deleted = true">
          <i class="fas fa-minus" />
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col">

        <b-form-group
          :name="`zahPar5.$each.${index}.prijmy`"
          :label="$t('message.lblPrijmy')">
          <template slot-scope="{ attrs, listeners }">
            <b-form-input
              v-bind="attrs"
              @input="zahPar5[index].prijmy = zahPar5[index].prijmy.toString().replace(',', '.')"
              v-model.trim="zahPar5[index].prijmy"
              v-on="listeners" />
          </template>
        </b-form-group>

        <b-form-group
          :name="`zahPar5.$each.${index}.outland_tax`">
          <template slot-scope="{ attrs, listeners }">
            <b-form-checkbox
              v-bind="attrs"
              v-model="zahPar5[index].outland_tax"
              value="1"
              unchecked-value="0"
              plain
              v-on="listeners">
              {{ $t('message.lblPrijmyZaplatene') }}
            </b-form-checkbox>
          </template>
        </b-form-group>

        <b-form-group
          :name="`zahPar5.$each.${index}.krajina`"
          class="required"
          :label="$t('message.lblKraj')">
          <template slot-scope="{ attrs, listeners }">
            <b-form-select
              class="alignL"
              v-bind="attrs"
              v-model.trim="zahPar5[index].krajina"
              :options="kraj"
              v-on="listeners"
              @input="setKurz(index)">
              <template slot="first">
                <option value="">{{ $t('message.msgSelect') }}</option>
              </template>
            </b-form-select>
          </template>
        </b-form-group>

        <b-form-group
          :name="`zahPar5.$each.${index}.kurz`"
          :label="$t('message.lblKurz')">
          <template slot-scope="{ attrs, listeners }">
            <b-form-input
              v-bind="attrs"
              @input="zahPar5[index].kurz = zahPar5[index].kurz.toString().replace(',', '.')"
              v-model.trim="zahPar5[index].kurz"
              v-on="listeners" />
          </template>
        </b-form-group>
      </div>

      <div class="col">

        <b-form-group
          v-for="(item, key) in col"
          :key="key"
          :name="item.name"
          :label="item.label">
          <template slot-scope="{ attrs, listeners }">
            <b-form-input
              v-bind="attrs"
              @input="
              zahPar5[index][key] = zahPar5[index][key].toString().replace(',', '.')"
              v-model="zahPar5[index][key]"
              v-on="listeners" />
          </template>
        </b-form-group>

      </div>
    </div>
  </div>
</template>

<script>
import bFormGroup from '@/components/form-group-col5'

export default {
  components: {
    bFormGroup
  },

  props: {
    index: {
      type: Number,
      required: true
    },
    zahPar5: {
      type: Array,
      required: true
    },
    kraj: {
      type: Array,
      required: true
    },
    kurzy: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      col: {
        socialne: {
          name: `zahPar5.$each.${this.index}.socialne`,
          label: this.$t('message.lblSoc')
        },
        zdravotne: {
          name: `zahPar5.$each.${this.index}.zdravotne`,
          label: this.$t('message.lblZdr')
        },
        odvody: {
          name: `zahPar5.$each.${this.index}.odvody`,
          label: this.$t('message.lblOdvody')
        }
      }
    }
  },

  methods: {
    setKurz (i) {
      const z = this.zahPar5
      
      if (z[i].krajina !== '') {
        z[i].kurz = this.kurzy[z[i].krajina]
      } else {
        z[i].kurz = ''
      }
    }
  }
}
</script>

<style scoped>
.p12 .form-check {
    width: 12%;
}
.item-title {
    margin-top: 3.5%;
    text-align: right;
    font-weight: bold;
}
.pull-right {
    float: right;
}
.remove-item {
    display: inline !important;
    margin-left: 1em !important;
}
</style>
